import React, { useState, useEffect } from   'react';
import { useNavigate } from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import { useForm } from 'react-hook-form';
import { Card, Button, Form, Row, Col, Modal } from 'react-bootstrap';
import 'react-datepicker/dist/react-datepicker.css';
import CargandoSpinner from '../Utils/CargandoSpinner';
import { FaCartPlus, FaGraduationCap, FaHome, FaIdCard, FaMoneyBill, FaPlusSquare, FaUsers, FaWalking, } from 'react-icons/fa';
import ReporteHogaresYPersonas from './ReporteHogaresYPersonas';
import ReporteIdentidad from './ReporteIdentidad';
import ReporteSalud from './ReporteSalud';
import ReporteEducacion from './ReporteEducacion';
import ReporteGeneracionIngresos from './ReporteGeneracionIngresos';
import ReporteAlimentacion from './ReporteAlimentacion';
import ReporteVivienda from './ReporteVivienda';
import ReporteReunificacion from './ReporteReunificacion';

export default function SSVConsultas() {
    const { token, rol } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [showModalHogar, setShowModalHogar] = useState(false);
    const handleCloseModalHogar = () => setShowModalHogar(false);
    const handleShowModalHogar = () => setShowModalHogar(true);
    const [showModalPersona, setShowModalPersona] = useState(false);
    const handleCloseModalPersona = () => setShowModalPersona(false);
    const handleShowModalPersona = () => setShowModalPersona(true);
    const [campoHogarSeleccionado, setCampoHogarSeleccionado] = useState(null);
    const [campoPersonaSeleccionado, setCampoPersonaSeleccionado] = useState(null);
    const [codigoProyecto, setCodigoProyecto] = useState(null);
    const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);
    const [proyectoEncuesta, setProyectoEncuesta] = useState([]);
    const [datosHogaresYPersonas, setDatosHogaresYPersonas] = useState(null);
    const [datosIdentidad, setDatosIdentidad] = useState(null);
    const [datosSalud, setDatosSalud] = useState(null);
    const [datosEducacion, setDatosEducacion] = useState(null);
    const [datosGeneracionIngresos, setDatosGeneracionIngresos] = useState(null);
    const [datosAlimentacion, setDatosAlimentacion] = useState(null);
    const [datosVivienda, setDatosVivienda] = useState(null);
    const [datosReunificacion, setDatosReunificacion] = useState(null);
    async function cargarProyectos() {
        try {
            setCargando(true);
            const response = await apiService.get('/encuestassv/reportes/obtenerproyectos', token);
            setProyectoEncuesta(response.data);            
        } catch (error) {
            console.error('Error al cargar proyectos:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los proyectos. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    useEffect(() => {
        cargarProyectos();
    }, []);
    async function cargarDatosHogaresYPersonas(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultarhogarespersonasproyectossv/${proyectoId}`, token);
            setDatosHogaresYPersonas(response.data);
        } catch (error) {
            console.error('Error al cargar datos de hogares y personas:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de hogares y personas. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosIdentidad(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatosidentidadssv/${proyectoId}`, token);
            setDatosIdentidad(response.data.datosIdentidad);
        } catch (error) {
            console.error('Error al cargar datos de identidad:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de identidad. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosSalud(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatossaludssv/${proyectoId}`, token);
            setDatosSalud(response.data.datosSalud);
        } catch (error) {
            console.error('Error al cargar datos de salud:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de salud. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosEducacion(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatoseducacionssv/${proyectoId}`, token);
            setDatosEducacion(response.data.datosEducacion);
        } catch (error) {
            console.error('Error al cargar datos de educación:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de educación. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosGeneracionIngresos(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatosgeneracioningresosssv/${proyectoId}`, token);
            setDatosGeneracionIngresos(response.data.datosGeneracionIngresos);
        } catch (error) {
            console.error('Error al cargar datos de generación de ingresos:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de generación de ingresos. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosAlimentacion(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatosalimentacionssv/${proyectoId}`, token);
            setDatosAlimentacion(response.data.datosAlimentacion);
        } catch (error) {
            console.error('Error al cargar datos de alimentación:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de alimentación. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosVivienda(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatosviviendassv/${proyectoId}`, token);
            setDatosVivienda(response.data.datosVivienda);
        } catch (error) {
            console.error('Error al cargar datos de vivienda:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de vivienda. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    async function cargarDatosReunificacion(proyectoId) {
        try {
            setCargando(true);
            const response = await apiService.get(`/encuestassv/consultas/consultardatosreunificacionssv/${proyectoId}`, token);
            setDatosReunificacion(response.data.datosReunificacion);
        } catch (error) {
            console.error('Error al cargar datos de reunificación:', error);
            setSwalProps({
                show: true,
                title: 'Error',
                text: 'No se pudieron cargar los datos de reunificación. Por favor, intente nuevamente.',
                icon: 'error',
            });
        } finally {
            setCargando(false);
        }
    }
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <Row className="mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">SSV Consultas</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">SSV Consultas</li>
                        </ol>
                    </div>
                    </Row>
                </div>
            </div>
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <Card>
                        <Card.Body>
                                    <Row>
                                <Col md={6}>
                                <Form.Label>Seleccione un proyecto para ver los reportes</Form.Label>
                                <Form.Control as="select" 
                                    id="slcCodigoProyecto" 
                                    style={{width: '100%'}}
                                    value={proyectoSeleccionado}
                                    onChange={(e) => setProyectoSeleccionado(e.target.value)}>
                                    <option value='0' ></option>
                                    {proyectoEncuesta.map((proyecto) => (
                                        <option key={proyecto.id} value={proyecto.id}>{proyecto.str_nombre}</option>
                                    ))}
                                </Form.Control>
                                </Col>
                            </Row>
                            <hr/>
                            <Row>
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaUsers/> </span>
                                            <div className="info-box-content">
                                            <span className="info-box-text">Hogar y personas</span>
                                            <Button id="verMasInfo" onClick={() => cargarDatosHogaresYPersonas(proyectoSeleccionado)}>Ver Reporte</Button>
                                        </div>
                                    </div>                        
                                </Col>}
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaIdCard/></span>

                                            <div className="info-box-content">
                                            <span className="info-box-text">Identificación</span>
                                            <Button id="verdIdentidad" onClick={() => cargarDatosIdentidad(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>
                                        </div>
                                    </Col>}
                                
                                
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaPlusSquare/></span>

                                            <div className="info-box-content">
                                            <span className="info-box-text">Salud</span>
                                            <Button id="verdsalud" onClick={() => cargarDatosSalud(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>
                                        </div>
                                    </Col>}
                                
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaGraduationCap/></span>

                                            <div className="info-box-content">
                                            <span className="info-box-text">Educación</span>
                                            <Button id="verdeducacion" onClick={() => cargarDatosEducacion(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>
                                            
                                        </div>
                                    
                                    </Col>}
                                
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaMoneyBill/></span>

                                            <div className="info-box-content">
                                            <span className="info-box-text">Generación de Ingresos</span>
                                            <Button id="verdGeneracionIng" onClick={() => cargarDatosGeneracionIngresos(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>
                                            
                                        </div>
                                    
                                    </Col>}

                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaCartPlus/></span>
                                            <div className="info-box-content">
                                            <span className="info-box-text">Alimentación</span>
                                            <Button id="verdAlimentacion" onClick={() => cargarDatosAlimentacion(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>
                                            
                                        </div>
                                    
                                    </Col>}
                                
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaHome/></span>

                                            <div className="info-box-content">
                                            <span className="info-box-text">Vivienda</span>
                                            <Button id="verdVivienda" onClick={() => cargarDatosVivienda(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>
                                            
                                        </div>
                                    
                                    </Col>}
                                
                                {proyectoSeleccionado && proyectoSeleccionado !== '0' && 
                                    <Col md={4} sm={6} xs={12}>
                                        <div className="info-box">
                                            <span className="info-box-icon bg-blue"><FaWalking/></span>

                                            <div className="info-box-content">
                                            <span className="info-box-text">Reunificación</span>
                                            <Button id="verdReunificacion" onClick={() => cargarDatosReunificacion(proyectoSeleccionado)}>Ver Reporte</Button>
                                            </div>                            
                                        </div>
                                    
                                    </Col>}
                                
                            </Row>
                        </Card.Body>
                    </Card>
                    {datosHogaresYPersonas && <ReporteHogaresYPersonas datosHogares={datosHogaresYPersonas?.datosHogares} datosPersonas={datosHogaresYPersonas?.datosPersonas} />}  
                    {datosIdentidad && <ReporteIdentidad datosIdentidad={datosIdentidad}/>}
                    {datosSalud && <ReporteSalud datosSalud={datosSalud.salud} datosPsicosocial={datosSalud.psicosocial}/>}
                    {datosEducacion && <ReporteEducacion datosEducacion={datosEducacion} />}
                    {datosGeneracionIngresos && <ReporteGeneracionIngresos datosGeneracionIngresos={datosGeneracionIngresos} />}
                    {datosAlimentacion && <ReporteAlimentacion dataAlimentacion={datosAlimentacion} />}
                    {datosVivienda && <ReporteVivienda dataVivienda={datosVivienda} />}
                    {datosReunificacion && <ReporteReunificacion dataReunificacion={datosReunificacion} />}
                    <Row>
                        <Modal show={showModalHogar} onHide={handleCloseModalHogar}>
                            <Modal.Header closeButton>
                            <Modal.Title>Incluir campos de hogar</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Seleccione campo</p>
                                <Form.Control as="select" multiple="" id="slcMdlColsHogar" value={campoHogarSeleccionado} onChange={(e) => setCampoHogarSeleccionado(e.target.value)} size="20" style={{width: '100%'}}>
                                    <option value='0' ></option>
                                </Form.Control>  
                            </Modal.Body>
                            <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModalHogar}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleCloseModalHogar}>
                                Seleccionar
                            </Button>
                            </Modal.Footer>
                        </Modal>
                        
                        <Modal show={showModalPersona} onHide={handleCloseModalPersona}>
                            <Modal.Header closeButton>
                            <Modal.Title>Incluir campos de Persona</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <p>Seleccione campo</p>
                                <Form.Control as="select" multiple="" id="slcMdlColsPersona" value={campoPersonaSeleccionado} onChange={(e) => setCampoPersonaSeleccionado(e.target.value)} size="20" style={{width: '100%'}} >
                                <option value='0' ></option>
                                </Form.Control>  
                            </Modal.Body>
                            <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModalPersona}>
                                Cancelar
                            </Button>
                            <Button variant="primary" onClick={handleCloseModalPersona}>
                                Seleccionar
                            </Button>
                            </Modal.Footer>
                        </Modal>
                        
                        <div id="mnuconspersonalizada" className="col-lg-4 col-xs-6">
                        
                        <div className="small-box bg-blue">
                            <div className="inner">
                            <h3>Consultas<sup style={{fontSize: '20px'}}></sup></h3>
                            <p>Definir consulta personalizada...</p>
                            </div>
                            <div className="icon">
                            <i className="fa fa-info"></i>
                            </div>
                            <button className="small-box-footer" style={{cursor: 'pointer', background: 'none', border: 'none', padding: 0}}>
                            Click aqui... <i className="fa fa-arrow-circle-right"></i>
                            </button>
                        </div>
                        </div>
                        
                        
                    </Row>
                    
                    
                    <Row>
                        <div id="divconsultaderechopersona" className="col-md-8 col-sm-8 col-xs-12">
                        <div className="info-box">
                            <span className="info-box-icon bg-blue"><i className="fa fa-child"></i></span>

                            <div className="info-box-content">
                            <span className="info-box-text">Consultar derechos por hogar</span>
                            <input id="txtIdencIdficha" className="form-control" type="text" placeholder="La Identificacion de la Ficha es el numero de Cedula del Jefe de Hogar"/>
                            <button id="idVerDerechosHogar" type="button" className="btn btn-block btn-primary btn-xs">Consultar</button>
                            <div hidden id="divestadoderechos">
                                <div className="box box-solid">
                                    <div className="box-body">
                                    <h3>Estado de derechos</h3>
                                    <ul>
                                    <li><button id="linkidentificacion" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semident" className="fa fa-circle text-yellow"></i> <span>Identificación</span></button></li>
                                    <li><button id="linksalud" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semasalud" className="fa fa-circle text-yellow"></i> <span>Salud</span></button></li>
                                    <li><button id="linkedu" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semaedu" className="fa fa-circle text-yellow"></i> <span>Educación</span></button></li>
                                    <li><button id="linkfuerztra" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semaFtrabajo" className="fa fa-circle text-yellow"></i> <span>Generación de Ingresos</span></button></li>
                                    <li><button id="linkvivienda" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semavivien" className="fa fa-circle text-yellow"></i> <span>Vivienda</span></button></li>
                                    <li><button id="linkalimentacion" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semalim" className="fa fa-circle text-yellow"></i> <span>Alimentación</span></button></li>
                                    <li><button id="linkreunificacion" style={{background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', textDecoration: 'none'}} ><i id="semareun" className="fa fa-circle text-yellow"></i> <span>Reunificación Familiar</span></button></li>
                                    </ul>      
                                    </div>
                                </div>
                            </div>
                            </div>
                            
                        </div>
                        
                        </div>
                    </Row>
                    
                    <Row>
                        <div className="box-header with-border">
                        <h2 className="box-title"><i className="fa fa-tag"></i> Analisis VUR</h2>
                        </div>
                        <div className="col-md-6">
                        <a className="btn btn-app" href="../model/analisis/datos.php">
                            <i className="fa fa-database"></i> Datos
                        </a>
                        <a className="btn btn-app" href="../model/analisis/Datos_SAN.php">
                            <i className="fa fa-database"></i> Datos_SAN
                        </a>
                        <a className="btn btn-app" href="../model/analisis/Datos_GI.php">
                            <i className="fa fa-database"></i> Datos_GI
                        </a>
                        <a className="btn btn-app" href="../model/analisis/Datos_Vivienda.php">
                            <i className="fa fa-database"></i> Datos_Vivienda
                        </a>
                        </div>
                        
                    </Row>
                    
                    <Row id="conspersonalizadadiv">
                        <div className="box box-default">
                        <div className="box-header with-border">
                            <h3 className="box-title">Consultas personalizadas</h3>
                
                            <div className="box-tools pull-right">
                            <button type="button" className="btn btn-box-tool" data-widget="collapse"><i className="fa fa-minus"></i></button>
                            <button type="button" className="btn btn-box-tool" data-widget="hide" ><i className="fa fa-remove"></i></button>
                            </div>
                        </div>
                        
                        <div className="box-body">
                            <p>Seleccione el proyecto</p>
                            <Form.Control as="select" className="form-control" id="slcMdlCodigoProyecto" value={codigoProyecto} onChange={(e) => setCodigoProyecto(e.target.value)} style={{width: '100%'}}>
                            <option value='0' ></option>
                            </Form.Control>
                            
                            <div className="box box-primary">
                            <div className="box-header">
                                
                            </div>
                            <div className="box-body">
                                <div>
                                <div className="row">
                                    <div className="col-md-12">
                                    <h3 className="box-title">Variables de hogar</h3>
                                    <div className="btn btn-box-tool">
                                        <Button variant="primary" onClick={handleShowModalHogar}>
                                            Insertar campos
                                        </Button>
                                        <Button variant="primary" onClick={handleShowModalPersona}>
                                            Insertar campos
                                        </Button>
                                    </div>
                                    </div>
                                    <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                        <tr><th>Campo</th><th>Criterios</th></tr>
                                        </thead>
                                        <tbody id="tblhogarcols">
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                                
                                <div className="row">
                                    <div className="col-md-12">
                                    <h3 className="box-title">Variables de persona</h3>
                                    <div className="btn btn-box-tool">
                                    <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modal-consultaDinamicapersona">
                                        Insertar campos
                                    </button>
                                    </div>
                                    </div>
                                    
                                    <div className="form-group">
                                    <table className="table table-bordered">
                                        <thead>
                                        <tr><th>Campo</th><th>Criterios</th></tr>
                                        </thead>
                                        <tbody id="tblpersonacols">
                                        
                                        </tbody>
                                    </table>  
                                    </div>
                                </div>
                                </div>
                            </div>
                            
                            <div className="box-footer">
                                <div hidden id="btnGencons">
                                <button type="button" className="btn btn-primary pull-right" data-dismiss="modal" >Generar consulta</button>  
                                </div>
                            </div>
                            </div>
                            
                        </div>
                        
                        
                        </div>
                    </Row>
                </div>
                <SweetAlert2 {...swalProps} 
                    didClose={() => {
                        setSwalProps({})
                    }}/>
                <Tooltip style={{zIndex:"100"}} id="tooltiparriba" place="right"/>
            </section>            
        </div>
      
  )
  }